import styled from 'styled-components';

import AssignmentMap from '../component';

import stopMarkerStyles from './stopMarkerStyles';
import driverMarkerStyles from './driverMarkerStyles';

export default styled(AssignmentMap)`
  height: 560px;
  ${stopMarkerStyles}
  ${driverMarkerStyles}
`;

export const StyledTimeLabel = styled.div`
  line-height: 10px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 30px;
  .dash {
    line-height: 4px;
  }
`;

export const StyledKey = styled.div`
  line-height: 10px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 18px;
  width: 18px;
`;
